import { Icon } from '@getsynapse/design-system';
import { renderTooltipArrow } from './Tooltip';
import { renderAlreadyAddedTooltip } from './Tooltip';

const renderSelectedCardIndicator = () => {
  return <Icon name='checkmark-outline' className='text-2xl font-extrabold' />;
};

export const renderStatusIndicator = (
  isSelected: boolean,
  isExisting: boolean,
  categoryIndex: number
) => {
  if (!isExisting && !isSelected) return null;

  return (
    <div
      className='absolute right-0 top-0 w-8 h-8 rounded flex justify-center items-center'
      style={{ background: 'inherit' }}
    >
      {isExisting
        ? renderExistingCardIndicator(categoryIndex)
        : renderSelectedCardIndicator()}
    </div>
  );
};

const renderExistingCardIndicator = (categoryIndex: number) => {
  return (
    <div className='relative flex h-full w-full justify-center items-center'>
      <Icon name='checkmark-outline' className='text-2xl font-extrabold' />
      {renderAlreadyAddedTooltip(categoryIndex)}
      {renderTooltipArrow()}
    </div>
  );
};
